import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/13f66ozi_biro_logo_black-350x100.png";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/t9aptkmj_biro_white.png";

export default function Navbar({ onBookingClick }) {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const linkClass = scrolled ? "text-neutral-700 hover:text-black" : "text-white/90 hover:text-white";

    return (
        <nav
            data-testid="main-navbar"
            className={`fixed top-0 w-full z-50 transition-all duration-300 ${
                scrolled ? "bg-white/95 backdrop-blur-xl border-b border-neutral-200/50 shadow-sm" : "bg-gradient-to-b from-black/40 to-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
                <a href="/" className="flex items-center">
                    <img src={scrolled ? LOGO_BLACK : LOGO_WHITE} alt="Birò" className="h-6 md:h-7 transition-all" />
                </a>
                <div className="hidden md:flex items-center gap-10">
                    <Link to="/biro-small" className={`text-sm font-medium transition-colors tracking-wide ${linkClass}`}>Birò Small</Link>
                    <Link to="/biro-big" className={`text-sm font-medium transition-colors tracking-wide ${linkClass}`}>Birò Big</Link>
                    <a href="/#how-it-works" className={`text-sm font-medium transition-colors tracking-wide ${linkClass}`}>Hur det fungerar</a>
                    <a href="/#contact" className={`text-sm font-medium transition-colors tracking-wide ${linkClass}`}>Kontakt</a>
                    <button
                        data-testid="nav-booking-cta"
                        onClick={onBookingClick}
                        className={`px-6 py-2.5 text-xs uppercase tracking-[0.2em] font-medium transition-colors ${
                            scrolled ? "bg-black text-white hover:bg-neutral-800" : "bg-white text-black hover:bg-neutral-100"
                        }`}
                    >
                        Boka provkörning
                    </button>
                </div>
                <button
                    data-testid="mobile-menu-toggle"
                    className="md:hidden p-2"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    {menuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            {menuOpen && (
                <div className="md:hidden bg-white border-t border-neutral-100 px-6 py-6 space-y-4">
                    <Link to="/biro-small" className="block text-sm font-medium text-neutral-700" onClick={() => setMenuOpen(false)}>Birò Small</Link>
                    <Link to="/biro-big" className="block text-sm font-medium text-neutral-700" onClick={() => setMenuOpen(false)}>Birò Big</Link>
                    <a href="/#how-it-works" className="block text-sm font-medium text-neutral-700" onClick={() => setMenuOpen(false)}>Hur det fungerar</a>
                    <a href="/#contact" className="block text-sm font-medium text-neutral-700" onClick={() => setMenuOpen(false)}>Kontakt</a>
                    <button
                        data-testid="mobile-booking-cta"
                        onClick={() => { setMenuOpen(false); onBookingClick(); }}
                        className="w-full bg-black text-white px-6 py-3 text-xs uppercase tracking-[0.2em] font-medium"
                    >
                        Boka provkörning
                    </button>
                </div>
            )}
        </nav>
    );
}
